const colors = {
  // TODO/HINT REMOVER Cores projeto anterior
  white: "#ffffff",
  whiteSmoke: "#F1F1F1",

  lightGray: "#E6E6E6",
  softGray: "#DFDFDF",
  gray: "#CECECE",
  darkGray: "#818181",
  darkerGray: "#1D1D18",

  black: "#262626",
  orange: "#DEA017",
  yellow: "#EAEF22",
  lightBlue: "#01DFDE",
  blue: "#0168FA",
  green: "#68CF00",
  redError: "#F0166D",
  red: "#E00000",

  // TODO/HINT pegar cores totais e mesclar aqui
  //
  //
  darkOpacity: "#00000020",
};

export default colors;
